// removed by extract-text-webpack-plugin
module.exports = {"folder-icon":"folder-icon","ant-pagination-item-active":"ant-pagination-item-active"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pgd/recycleBin/Index.scss
// module id = 1426
// module chunks = 0